import React from 'react';

export const PropsViewPanel = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      id="preferences-propsview-panel"
      className="flex m-2 PreferencesPanel PreferencesPropsViewPanel PreferencesStandalonePropsViewPanel"
    >
      {children}
    </div>
  );
};
